/** Stateful critical-lab-value acknowledgment lifecycle — backs /lab/critical-alerts/... */
import { fetchApi } from '../client';

export const labCriticalAlertsModule = {
  list: (status?: string[]) => {
    const qs = status && status.length ? `?${status.map(s => `status=${s}`).join('&')}` : '';
    return fetchApi<any[]>(`/api/lab/critical-alerts${qs}`);
  },

  acknowledge: (alertId: string) =>
    fetchApi<any>(`/api/lab/critical-alerts/${alertId}/acknowledge`, { method: 'POST' }),

  escalate: (alertId: string, escalateToUserId?: string) =>
    fetchApi<any>(`/api/lab/critical-alerts/${alertId}/escalate`, {
      method: 'POST',
      body: JSON.stringify({ escalateToUserId }),
    }),
};
